import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user
  const [error, setError] = useState("");

  const checkAuth = useCallback(async () => {
    try {
      // suppress console noise for the expected 401 on public pages
      const { data } = await api.get("/auth/me", { validateStatus: (s) => s < 500 });
      if (data && data.id) setUser(data); else setUser(false);
    } catch (_e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return null;
    }
  };

  const register = async (payload) => {
    setError("");
    try {
      const { data } = await api.post("/auth/register", payload);
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return null;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, error, setError, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
